export var makeBadgeStyles = function makeBadgeStyles(_ref) {
  var primitives = _ref.primitives,
    tokens = _ref.tokens;
  return {
    MuiBadge: {
      styleOverrides: {
        root: {
          "& [class*='MuiBadge-standard'], [class*='MuiBadge-inline'], [class*='MuiBadge-outlined']": {
            fontSize: primitives.fontSizes["1"],
            borderRadius: primitives.borderRadii.round,
            fontWeight: primitives.fontWeights.stout,
            padding: "calc(".concat(primitives.spacings[1], " / 2) ").concat(primitives.spacings[2]),
            boxSizing: "initial",
            minWidth: primitives.spacings[3],
            minHeight: primitives.spacings[3],
            "&:has([class*='MuiSvgIcon'])": {
              padding: primitives.spacings[1]
            },
            "& [class*='MuiSvgIcon-root']": {
              color: "currentColor"
            }
          },
          "& [class*='MuiBadge-dot']": {
            padding: 0,
            minHeight: primitives.spacings[3],
            minWidth: primitives.spacings[3],
            borderRadius: primitives.borderRadii.round
          },
          "& [class*='MuiBadge-colorUrgency']": {
            backgroundColor: primitives.colors.accent.clay,
            color: tokens.colors["ink-on-fill-urgent"],
            "&[class*='MuiBadge-outlined']": {
              backgroundColor: tokens.colors["fill-alert-slight"],
              borderColor: tokens.colors["fill-alert"],
              color: tokens.colors["ink-on-background"]
            }
          },
          "& [class*='MuiBadge-colorSuccess']": {
            backgroundColor: primitives.colors.accent.plant,
            color: tokens.colors["ink-on-fill-success"],
            "&[class*='MuiBadge-outlined']": {
              backgroundColor: tokens.colors["fill-success-slight"],
              borderColor: tokens.colors["fill-success"],
              color: tokens.colors["ink-on-background"]
            }
          },
          "& [class*='MuiBadge-colorAttention']": {
            backgroundColor: primitives.colors.accent.gold,
            color: tokens.colors["ink-on-fill-warning"],
            "&[class*='MuiBadge-outlined']": {
              backgroundColor: tokens.colors["fill-warning-slight"],
              borderColor: tokens.colors["fill-warning"],
              color: tokens.colors["ink-on-background"]
            }
          },
          "& [class*='MuiBadge-colorNeutral']": {
            backgroundColor: primitives.colors.detail["slate-light"],
            color: tokens.colors["ink-on-light"],
            "&[class*='MuiBadge-outlined']": {
              backgroundColor: tokens.colors["detail-1-20"],
              borderColor: tokens.colors["detail-1-opaque"],
              color: tokens.colors["ink-on-background"]
            }
          }
        },
        badge: {
          backgroundColor: tokens.colors["fill-engage"],
          color: tokens.colors["ink-on-fill-engage"],
          "&[class*='MuiBadge-outlined']": {
            backgroundColor: tokens.colors["fill-engage-slight"],
            borderColor: tokens.colors["fill-engage"],
            color: tokens.colors["ink-on-background"]
          }
        },
        inline: {
          position: "static",
          transform: "none",
          transformOrigin: "initial"
        },
        outlined: {
          borderWidth: primitives.borderWidths.medium,
          borderStyle: "solid",
          position: "static",
          transform: "none",
          transformOrigin: "initial"
        }
      }
    }
  };
};